//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast,confirm} from 'vue-ydui/dist/lib.rem/dialog';
import QRCode from 'qrcodejs2'
import axios from 'axios';
import global_ from '../../components/Global'
import VueQr from 'vue-qr';
export default {
  data() {
    return {
      styleObj: {
        height: '',
        backgroundColor:'white'
      },
      ruleForm: {
        phone: '',
        code:''
      },
      is_sub:false,
      content:'',
      thumbnail:'',
      ticketNo:'',
      userInfo:{},
      qrUrl:'',
      businessesPhone:'',
      qrcode:''
    };
  },
  components: {
    VueQr
  },
  methods: {

    finish(){
      axios({
        method: "PUT",
        url: 'https://ypapp.cnnb.com.cn/web-nbcc/activity/ticket/verification2', //填写接口地址  全路径
        headers: {'ticket': this.userInfo.ticket,
          'module':'web-member'
        },
        data: {
          "ticketNo": this.ticketNo, //传递相关参数
        },
      }).then((res) => {
        if(res.code == 200 ){
          this.openConfrim();
          /*this.content = "使用成功";
          this.showToast(this.content,1500,'success')
          this.$router.push({ path: '/whk/productList',query: { businessesPhone:this.businessesPhone}});*/
        }else{
          this.content = res.message;
          this.showToast(this.content,1500,'error');
          //this.$router.push({ path: '/whk/productList',query: { businessesPhone:this.businessesPhone}});
        }

      });

    },
    openConfrim() {
      this.$dialog.alert({mes: '核销成功'});
      this.$router.push({ path: '/whk/productList',query: { businessesPhone:this.businessesPhone}});
      /*this.$dialog.confirm({
        title: '',
        mes: '核销成功',
        opts: () => {
          //this.$dialog.toast({mes: '你点了确定', timeout: 1000});
          this.$router.push({ path: '/whk/productList',query: { businessesPhone:this.businessesPhone}});
        }
      });*/
    },
    showToast(content,timeout,icon){
      this.$dialog.toast({
        mes: content,
        timeout: timeout,
        icon: icon,
      });
    },
    /*qrcode () {
      this.qrcode = new QRCode('qrcode',{
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: this.ticketNo   // 设置二维码内容或跳转地址
      })
    }*/

  },
  mounted () {
      this.styleObj.height = $(window).height() + 'px';
    this.thumbnail = this.$route.query.thumbnail;
    this.ticketNo = this.$route.query.ticketNo;
    this.businessesPhone = this.$route.query.businessesPhone;
    var json = localStorage.getItem("userInfo");
    this.userInfo = JSON.parse(json);
    this.qrUrl = this.ticketNo;
    this.qrcode = new QRCode('qrcode',{
      width: 200, // 设置宽度，单位像素
      height: 200, // 设置高度，单位像素
      text: this.ticketNo   // 设置二维码内容或跳转地址
    })
  }
};



// WEBPACK FOOTER //
// ./src/pages/whk/write_off.vue